const urlArray = window.location.href.split("/");
const customer = urlArray[urlArray.findIndex((element) => element == "app")+1];
export default {	
		auth: require('@websanova/vue-auth/drivers/auth/devise.js'),
		http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
		router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
		loginData: {url: 'auth/sign_in', method: 'POST', redirect: {name: 'login'}, fetchUser: true},
		registerData: {url: 'auth', method: 'POST', redirect: {name: 'login'}},
		logoutData: {url: 'auth/sign_out', method: 'DELETE', redirect: {name: 'login'}, makeRequest: false},
		fetchData: {url: 'auth/validate_token', method: 'GET', enabled: true},
		refreshData: {url: 'user_token/', method: 'GET', enabled: false, interval: 0},
		authRedirect: {path: `/app/${customer}/login`}
}